import React from 'react'
import { useStyles } from './LoadingStateComponent.styles'
import { Typography } from '@mui/material'
import labraLogo from '../../images/new_labra_logo_compact.svg'
import { LoadingSpinner } from '@labrav/react-components'

export interface LoadingStateProps {
  heading: string
  description: string
}

export const LoadingStateComponent: React.FC<LoadingStateProps> = ({
  heading,
  description,
}) => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.loaderRootContainer}
      data-testid="loader-state-component"
    >
      <img src={labraLogo} className={classes.logoImg} />
      <Typography data-testid="loading-header" className={classes.loaderHeader}>
        {heading}
      </Typography>
      <Typography
        data-testid="loading-sub-header"
        className={classes.loaderSubHeader}
      >
        {description}
      </Typography>
      <LoadingSpinner className={classes.loadingSpinner} />
    </div>
  )
}
